module.exports = __webpack_public_path__ + "static/media/e7ee48e4c9f84841e86043ac7235b63f.7e22883a.mp4";